import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import './ChipsFiltrosAtivos.css';

const ChipsFiltrosAtivos = ({ chips }) => {
  if (!chips || chips.length === 0) return null;

  return (
    <Box className="chips-filtros-container">
      <Typography variant="body2" className="chips-filtros-label">
        Filtros ativos:
      </Typography>
      <Box className="chips-filtros-lista">
        {chips.map(chip => (
          <Chip
            key={chip.chave}
            label={`${chip.label}: ${chip.valor}`}
            variant="outlined"
            color="primary"
            size="small"
            className="chip-filtro-ativo"
          />
        ))}
      </Box>
    </Box>
  );
};

export default ChipsFiltrosAtivos;
